import { Outlet } from "react-router";
import Header from "../../component/layout/header";
import useNav from "../../script/tabingNavArray";

const SystemSettingsLayout = () => {
  const navList = useNav();
  let { systemSettingsBottomHeader, systemSettingsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={systemSettingsBottomHeader} topTabs={systemSettingsTopHeader} />
      <Outlet />
    </div>
  );
};

export default SystemSettingsLayout;
